<template>
  <div class="info-view">
    <div class="info-container">
      <div class="success-icon">
        <i class="fas fa-check-circle"></i>
      </div>
      <h1>Registration Complete!</h1>
      <p>Your registration has been successfully completed. Please check your registered email for your login credentials.</p>
      <router-link to="/customer-signin" class="login-link">
        <button class="login-button">Go to Login</button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoView'
}
</script>

<style scoped>
.info-view {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.info-container {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 500px;
  width: 90%;
}

.success-icon {
  font-size: 4rem;
  color: #4CAF50;
  margin-bottom: 1rem;
}

h1 {
  color: #333;
  margin-bottom: 1rem;
}

p {
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.5;
}

.login-button {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-button:hover {
  background-color: #45a049;
}

.login-link {
  text-decoration: none;
}
</style> 